const DropdownMenuDivider = () => {
  return <li role="separator" className="rs-dropdown-item-divider"></li>;
};

export default DropdownMenuDivider;
